import {
  ASSET_PRICE_LOW_VALUE_THRESHOLD,
  intlFiatValueFormatting,
} from '@bts-web/utils-formatting';
import { getAppConfig } from '@bts-web/core-app-config';
import { TradeOfferDataNonNullable } from '../types';
import { TradeScreenTranslations } from '../../utils';

export const getFeesListItemsForTrade = (
  tradeOfferData: TradeOfferDataNonNullable,
  translations: Pick<
    TradeScreenTranslations,
    | 'buyVolume'
    | 'buyAmount'
    | 'sellVolume'
    | 'bank_transfer'
    | 'sellAmount'
    | 'offerPrice'
    | 'tradeFee'
    | 'tradeFeeInclVAT'
    | 'paymentMethod'
  >,
  config: {
    currentLocale: string;
    variant: 'buy' | 'sell';
    currency: string;
    isPaymentMethodVisible: boolean;
  },
) => {
  const { isUAETenant } = getAppConfig();

  return [
    ...(config.isPaymentMethodVisible
      ? [
          {
            title: translations.paymentMethod,
            value: translations.bank_transfer,
          },
        ]
      : []),
    {
      title:
        config.variant === 'buy'
          ? translations.buyVolume
          : translations.sellVolume,
      value: tradeOfferData.volume
        ? intlFiatValueFormatting(tradeOfferData.volume.value, {
            locale: config.currentLocale,
            notation: 'standard',
            currency: config.currency,
            fractionDigits: tradeOfferData.volume.precision,
          })
        : '',
    },
    {
      title:
        config.variant === 'buy'
          ? translations.buyAmount
          : translations.sellAmount,
      // we shall not parse this number to apply the precision, it can lead to 10.0000000001 instead of 10.0, we will use the precision from the tradeOfferData response
      value: tradeOfferData.assetAmount
        ? `${Number(tradeOfferData.assetAmount.value)} ${tradeOfferData.asset.symbol}`
        : '',
    },
    {
      title: translations.offerPrice,
      value: tradeOfferData.assetNetConversionRate
        ? intlFiatValueFormatting(
            tradeOfferData.assetNetConversionRate.value, // assetNetConversionRate excludes fees
            {
              locale: config.currentLocale,
              notation: 'standard',
              currency: config.currency,
              fractionDigits: tradeOfferData?.assetNetConversionRate.precision,
            },
            ASSET_PRICE_LOW_VALUE_THRESHOLD,
          )
        : '',
    },
    {
      title: isUAETenant ? translations.tradeFeeInclVAT : translations.tradeFee,
      value: tradeOfferData.spread
        ? intlFiatValueFormatting(tradeOfferData.spread.value, {
            locale: config.currentLocale,
            notation: 'standard',
            currency: config.currency,
            fractionDigits: tradeOfferData?.spread.precision,
          })
        : '0',
    },
  ];
};
